export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13506.33f2fd87.jpg";